import { 
    useDispatch as useReduxDispatch,
    useSelector as useReduxSelector,
ß
} from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { ENABLE_REDUX_DEV_TOOLS } from '../constants';
import rootReducer from './rootReducer';
import thunk from 'redux-thunk'

const store = configureStore({
    reducer: rootReducer,
    devTools: ENABLE_REDUX_DEV_TOOLS,
    middleware: [thunk]
});

export const useSelector = useReduxSelector;

export const useDispatch = () => useReduxDispatch();

export default store;